import { Box, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { PropertyIconSelect } from "./propertyIconSelect";
import { Overview } from "./OverviewBlock";

interface Props {
  index: number;
  property: Overview;
  deletePropertyRow: (rowIndex: number) => void;
  handleChangeRow: (
    index: number,
    fieldName: string,
    value: string | boolean
  ) => void;
}

export const validOverviewPropLength = 30;
export const checkIsOverviewPropRowValid = (overview: Array<Overview>, isRequired:boolean = true) => {
  if (isRequired&& !overview) {
    return false
  }
  if (isRequired&&(overview.length < 2 || overview.length > 10)) {
    return false
  }
  if (
    overview.findIndex(
      (item) =>
        item.title.trim().length === 0 || item.title.length >= validOverviewPropLength
    ) != -1 ||
    overview.findIndex(
      (item) =>
        item.value.trim().length === 0 || item.value.length >= validOverviewPropLength
    ) != -1
  ) {
    return false;
  }
  return true;
};

export const PropertyRow = ({
  index,
  property,
  deletePropertyRow,
  handleChangeRow
}: Props) => {
  const [fields, setFields] = useState({
    title: {
      val: property.title,
      touched: false,
      error: property.title.trim().length > 0 ? false : true,
    },
    value: {
      val: property.value,
      touched: false,
      error: property.value.trim().length > 0 ? false : true,
    },
  });

  const handleChage = (e) => {
    const value = e.currentTarget.value;
    const name = e.currentTarget.name;

    setFields({
      ...fields,
      [name]: {
        ...fields[name],
        val: value,
        touched: true,
        error:
          value.length <= 0 || value.length >= validOverviewPropLength
            ? true
            : false,
      },
    });
  };

  const handleBlur = (e) => {
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;

    setFields({
      ...fields,
      [name]: {
        ...fields[name],
        touched: true,
        error:
          value.length <= 0 || value.length >= validOverviewPropLength
            ? true
            : false,
      },
    });
    handleChangeRow(index, name, value);
  };

  return (
    <Box
      key={index + property.icon}
      className="dreamHomeProperty_row"
      position="relative"
    >
      <PropertyIconSelect
        index={index}
        img={property.icon}
        handleChangeProperty={handleChangeRow}
      />
      <div className="dreamHomeProperty_fieldWrapper">
        <TextField
          variant="outlined"
          placeholder="Title"
          name="title"
          size="small"
          value={fields.title.val}
          key={"title"}
          className="dreamHomeProperty_input"
          onChange={handleChage}
          onBlur={handleBlur}
          error={fields.title.error}
        />
        <span>{`${fields.title.val.length}/${validOverviewPropLength}`}</span>
      </div>
      <div className="dreamHomeProperty_fieldWrapper">
        <TextField
          variant="outlined"
          placeholder="Value"
          size="small"
          name="value"
          key={"value"}
          value={fields.value.val}
          className="dreamHomeProperty_input"
          onChange={handleChage}
          onBlur={handleBlur}
          error={fields.value.error}
        />
        <span>{`${fields.value.val.length}/${validOverviewPropLength}`}</span>
      </div>
      <div className="deletePropertyRowBtn">
        <img
          src={require("../../../../extensions/images/trashIcon.png")}
          onClick={() => deletePropertyRow(index)}
        />
      </div>
    </Box>
  );
};
